// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   TextField,
//   FormControl,
//   Select,
//   MenuItem,
//   Checkbox,
//   ListItemText,
//   Divider
// } from "@mui/material";

// export default function UserWiseFilters({
//   searchTerm,
//   setSearchTerm,
//   filters,
//   setFilters,
// }) {
//   const [difficulties, setDifficulties] = useState([]);
//   const [examTypes, setExamTypes] = useState([]);

//   useEffect(() => {
//     const fetchOptions = async () => {
//       try {
//         const response = await fetch(`/reports/filter-options/`);
//         const data = await response.json();
//         console.log(data, "#######")

//         setDifficulties(Object.values(data.difficulties || []));
//         setExamTypes(Object.values(data.exam_types || []));

//       } catch (error) {
//         console.error("Error fetching filter options:", error);
//       }
//     };

//     fetchOptions();
//   }, []);

//   const handleFilterChange = (e) => {
//     const value = e.target.value;
//     setFilters(typeof value === "string" ? value.split(",") : value);
//   };

//   return (
//     <Box sx={{ display: "flex",gap:0.5, mb: 2, flexWrap: "wrap",                 // ✅ allow wrapping
//         alignItems: "center",}}>

//       <TextField
//         variant="outlined"
//         size="small"
//         placeholder="Search by Title, Difficulty, Type, Status or Date"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//         fullWidth
//         sx={{
//           width: 350,
//           "& .MuiOutlinedInput-root": {
//             height: "40px",
//             fontSize: "0.875rem",
//             background: "white",
//           },
//         }}
//       />

//       <FormControl fullWidth
//         sx={{
//           maxWidth: { xs: "100%", sm: 220 },
//         }}>
//         <Select
//           multiple
//           displayEmpty
//           value={filters}
//           onChange={handleFilterChange}
//           renderValue={(selected) =>
//             selected.length === 0 ? "All Filters" : selected.join(", ")
//           }
//           sx={{
//             height: "40px",
//             fontSize: "0.875rem",
//             background: "white",
//             "& .MuiSelect-select": { padding: "4px 10px" },
//           }}
//         >
//           <MenuItem value="All Difficulties">
//             <Checkbox checked={filters.includes("All Difficulties")} />
//             All Difficulties
//           </MenuItem>

//           {difficulties.map((d) => (
//             <MenuItem key={d} value={d}>
//               <Checkbox checked={filters.includes(d)} />
//               {d}
//             </MenuItem>
//           ))}

//           <Divider />

//           {examTypes.map((t) => (
//             <MenuItem key={t} value={t}>
//               <Checkbox checked={filters.includes(t)} />
//               {t}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//     </Box>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import axios from "axios";

// Syncfusion QueryBuilder imports
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-querybuilder/styles/material.css';

export default function UserWiseFilters({
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
  filterRule,
  setFilterRule,
}) {
  const [examTypes, setExamTypes] = useState([]);

  // QueryBuilder state
  const [showFilters, setShowFilters] = useState(false);
  const qbRef = useRef(null);
  const currentRuleRef = useRef({ condition: 'and', rules: [] });



  const stringOperators = [
    { value: 'contains', key: 'Contains' },
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'startswith', key: 'Starts With' },
    { value: 'endswith', key: 'Ends With' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const numberOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'Greater Than' },
    { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
    { value: 'lessthan', key: 'Less Than' },
    { value: 'lessthanorequal', key: 'Less Than Or Equal' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const dateOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'After' },
    { value: 'lessthan', key: 'Before' },
    { value: 'greaterthanorequal', key: 'On or After' },
    { value: 'lessthanorequal', key: 'On or Before' },
    { value: 'between', key: 'Between' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];


  const queryBuilderColumns = [
    { field: 'Title', label: 'Title', type: 'string', operators: stringOperators },
    { field: 'exam_type', label: 'Assessment Type', type: 'string', operators: stringOperators },
    // { field: 'difficulty', label: 'Difficulty', type: 'string', operators: stringOperators },
    { field: 'Status', label: 'Result', type: 'string', operators: stringOperators },
    { field: 'Percentage', label: 'Scored Percentage', type: 'number', operators: numberOperators },
    // { field: 'ExamEndTime', label: 'Date', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
  ];

  const defaultRule = { condition: 'and', rules: [] };

  const applyFilters = () => {
    const rule = currentRuleRef.current || defaultRule;
    setFilterRule(rule);
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setFilters([]);
    setFilterRule(null);
    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`/reports/filter-options/`, { withCredentials: true });
        const data = response.data;
        console.log(data, "#######");

        // setDifficulties(Object.values(data.difficulties || []));
        setExamTypes(Object.values(data.exam_types || []));

      } catch (error) {
        console.error("Error fetching filter options:", error);
      }
    };

    fetchOptions();
  }, []);

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilters(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <>
       <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search by Title, Assessment Type, Result, Scored Percentage.."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
      
            width: 350,
            "& .MuiOutlinedInput-root": {
              height: "40px",
              fontSize: "0.875rem",
              background: "white",
            },
          }}
        />

        {/* Enable Filters Button */}
        <button
          variant="outlined"
          className="btn"
          onClick={() => {
            if (showFilters) {
              if (qbRef.current) {
                qbRef.current.setRules(defaultRule);
                currentRuleRef.current = defaultRule;
              }

              setSearchTerm('');
              setFilters([]);
              setFilterRule(null);
            }

            setShowFilters(!showFilters);
          }}
        >
          {showFilters ? 'Close Filters' : 'Enable Filters'}
        </button>


      </Box>

      {/* Syncfusion QueryBuilder (conditionally visible) */}
      {showFilters && (
        <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd', mb: 2 }}>
          <QueryBuilderComponent
            ref={qbRef}
            dataSource={[]}
            columns={queryBuilderColumns}
            rule={defaultRule}
            ruleChange={(args) => { currentRuleRef.current = args.rule; }}
            created={() => {
              if (qbRef.current) qbRef.current.setRules(defaultRule);
            }}
            showButtons={false}
            summaryView={false}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
            <ButtonComponent cssClass="btn-negative" onClick={clearAllFilters}>
              Clear Filters
            </ButtonComponent>
            <ButtonComponent cssClass="btn" onClick={applyFilters}>
              Apply Filters
            </ButtonComponent>
          </Box>
        </Box>
      )}
    </>
  );
}
